import { useTheme } from '@/providers/theme/use-theme';
import { Menu, Search } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

interface AppTopbarProps {
  onOpenMenu: () => void;
}

export const AppTopbar = ({ onOpenMenu }: AppTopbarProps) => {
  const { theme, toggleTheme } = useTheme();
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const [params] = useSearchParams();
  const onCouples =
    pathname.startsWith('/admin/couples') &&
    !pathname.includes('/edit') &&
    !pathname.endsWith('/add');

  const [query, setQuery] = useState(onCouples ? (params.get('q') ?? '') : '');

  useEffect(() => {
    if (!onCouples) setQuery('');
    else setQuery(params.get('q') ?? '');
  }, [onCouples, params]);

  /** Digitar leva à lista de Casais filtrada em todos os encontros. */
  const handleSearch = (value: string) => {
    setQuery(value);
    const search = value ? `?q=${encodeURIComponent(value)}` : '';
    navigate(`/admin/couples${search}`, { replace: onCouples });
  };

  return (
    <header className="sticky top-0 z-20 border-b border-line bg-bg">
      <div className="flex items-center gap-4 px-7 py-3.5 max-sm:px-4">
        <button
          type="button"
          onClick={onOpenMenu}
          aria-label="Abrir menu"
          className="hidden size-10 items-center justify-center rounded-[10px] border border-line-2 text-ink max-[999px]:flex"
        >
          <Menu className="size-[18px]" />
        </button>
        <label className="flex h-10 max-w-[420px] flex-1 items-center gap-2.5 rounded-full border border-line-2 bg-surface px-3.5 text-muted focus-within:border-brand">
          <Search className="size-[17px] flex-none" />
          <input
            value={query}
            onChange={(e) => handleSearch(e.target.value)}
            placeholder="Buscar casal, telefone ou paróquia..."
            className="min-w-0 flex-1 border-0 bg-transparent p-0 text-sm text-ink outline-none placeholder:text-muted focus:ring-0"
          />
        </label>
        <div className="flex-1" />
        <button
          type="button"
          onClick={toggleTheme}
          title="Alternar tema"
          className="flex h-10 items-center gap-2 rounded-full border border-line-2 px-3.5 text-[13px] font-semibold whitespace-nowrap text-ink"
        >
          <span className="size-3.5 rounded-full border-[1.6px] border-current bg-[linear-gradient(90deg,currentColor_50%,transparent_50%)]" />
          <span className="max-sm:hidden">
            {theme === 'dark' ? 'Modo claro' : 'Modo escuro'}
          </span>
        </button>
      </div>
    </header>
  );
};
